import Sidebar from './Sidebar';

const ModelTab3 = () => {
	let Imple1 = 'https://static.igem.wiki/teams/5066/drylab/model-tab3-1.png';
	let Imple2 = 'https://static.igem.wiki/teams/5066/drylab/model-tab3-2.png';
	let Imple3 = 'https://static.igem.wiki/teams/5066/drylab/model-tab3-3.png';
	let Imple4 = 'https://static.igem.wiki/teams/5066/drylab/model-tab3-4.jpg';
	// let Imple5 = 'https://static.igem.wiki/teams/5066/drylab/model-tab3-5.png';

	let sections = [
		{ id: 's1', name: 'Introduction' },
		{ id: 's2', name: 'New Model' },
		{ id: 's3', name: 'Results' },
		{ id: 's4', name: 'Disscusion' },
		{ id: 's5', name: 'Limtation/Future' },
		{ id: 's6', name: 'References' },
	];

	return (
		<div className='flex'>
			<Sidebar sections={sections} />

			{/* Main Content */}
			<div className='flex-col w-full lg:p-[50px] p-[5px] my-[10px] space-y-16 rounded-2xl bg-white shadow-[-2px_4px_8px_-2px_rgba(0,0,0,0.2)]'>
				<div className='pb-12'>
					<section id='s1'>
						<h2 className='text-3xl font-bold text-[#C94C67]'>
							Introduction
						</h2>
						<div className='mt-4'>
							<p className='mt-2 text-gray-700'>
								After we finished our epidemiology model, we
								consulted with several stakeholders. WiAdvance
								is a company that helps local governments
								monitor dengue fever transmissions using
								artificial intelligence and professional Dr.
								Chen, the Chief Epidemiological Consultant for
								the National Mosquito Control Center and
								National Institute of Health. From our
								discussions with WiAdvance, we learned the
								importance of choosing the right time to
								implement our ovitraps. In the meeting with Dr
								Chen, he pointed out the lack of
								temperature-dependent entomological parameters
								in our model, suggesting that we include such
								parameter differences to present unfavorable and
								favorable mosquito conditions. The drylab team
								was then asked whether the timing for
								implementation would make an impact. Therefore,
								we developed a new model to investigate the best
								time to implement our larvicidal toxin in
								ovitraps within a year, such that the number of
								infected human population reaches a minimal
								peak.
							</p>
						</div>
					</section>
				</div>

				<div className='pb-12'>
					<section id='s2'>
						<h2 className='text-3xl font-bold text-[#C94C67]'>
							New Model
						</h2>
						<p className='mt-5 text-gray-700'>
							Warmer climates promote mosquito growth and allow
							them to live longer, which is why dengue fever is
							especially prevalent during the summer. Taking
							inspiration from literature (Sylvestre Aureliano
							Carvalho et al.), we separated the year into five
							sections differentiated by three conditions:
							unfavorable, less favorable, and more favorable.
							Parameters such as adult mosquito death rate and
							transition rates from egg to larva, larva to pupa,
							and pupa to adult mosquito change depending on the
							general temperature in the section of the year.
						</p>
						<br></br>
						<div className='overflow-x-auto max-w-lg mx-auto p-6'>
							<table className='min-w-full table-auto border-collapse border border-gray-300'>
								<thead>
									<tr>
										<th className='border border-gray-300 px-4 py-2'></th>
										<th className='border border-gray-300 px-4 py-2'>
											Unfavorable
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											More favorable
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											Favorable
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											More favorable
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											Unfavorable
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<th className='border border-gray-300 px-4 py-2'>
											t (days)
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											1 ~ 100
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											101 ~ 151
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											152 ~ 264
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											265 ~ 315
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											316 ~ 365
										</th>
									</tr>
									<tr>
										<th className='border border-gray-300 px-4 py-2'>
											Temperature (oC)
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											T &lt; 25
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											25 &lt; T &lt; 30
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											T &gt; 30
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											25 &lt; T &lt; 30
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											T &lt; 25
										</th>
									</tr>
									<tr>
										<th className='border border-gray-300 px-4 py-2'>
											Egg to Larva transition rate
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.2
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.303
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.5
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.303
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											{' '}
											0.2
										</th>
									</tr>
									<tr>
										<th className='border border-gray-300 px-4 py-2'>
											Larva to Pupa transition rate
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.067
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.125
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.227
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.125
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.067
										</th>
									</tr>
									<tr>
										<th className='border border-gray-300 px-4 py-2'>
											Pupa to Adult transition rate
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.091
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.323
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.625
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.323
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.091
										</th>
									</tr>
									<tr>
										<th className='border border-gray-300 px-4 py-2'>
											Mosquito death rate
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.059
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.04
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.029
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.04
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											0.059
										</th>
									</tr>
								</tbody>
							</table>
						</div>
						<p className='mt-5 text-gray-700 font-center'>
							Table 1. Parameters that change with temperature.
						</p>
						<p className='mt-1 text-gray-700'>
							We ran simulations with these new conditions using
							Euler’s method in a Matlab environment, which uses
							tiny incremental increases in time and repeated
							calculations of the slope to estimate the number of
							infectious humans. Then, we manipulated the time of
							ovitrap implementation to observe the change in the
							number of infected humans.
						</p>
						<p className='mt-1 text-gray-700'>
							In our initial trials, we implemented the ovitraps
							at vastly varying conditions. We modeled the
							implementation timings to be at the end of the first
							unfavorable period, the middle of the first less
							favorable period, and the beginning of the favorable
							period. Then, we narrowed it down to more specific
							days to find the exact day of optimal
							implementation.
						</p>
					</section>
				</div>

				<div className='pb-12'>
					<section id='s3'>
						<h2 className='text-3xl font-bold text-[#C94C67]'>
							Results
						</h2>
						<img src={Imple1} alt='imp_img'></img>
						<img src={Imple2} alt='imp_img'></img>
						<p className='mt-2 text-gray-700'>
							The optimal time for implementing our ovitraps is
							indicated by the graph with the lowest peak in the
							infected human population. The dotted line in this
							diagram represents the infected human population
							without any intervention. The three other colored
							graphs represent the infected human population after
							the implementation of our ovitraps on specific days
							after the start of the year. The graph with the
							lowest peak in this diagram represents ovitrap and
							toxin introduction on day 230 (blue), indicating the
							optimal timing for implementation to be day 230. The
							other two graphs in this diagram, red and green,
							indicate early and late implementation on days 185
							and 237, respectively. This emphasizes the
							importance of timing since both early and late
							implementation would reduce the efficacy of our
							ovitraps or any type of vector control.
						</p>
						<img src={Imple3} alt='imp_img'></img>
						<p className='mt-3 text-gray-700'>
							We narrowed down and finally determined the optimal
							time for implementation by plotting graphs
							representing intervention days that vary relative to
							each other by one day. We concluded that the optimal
							timing for implementation is on day 230, that’s
							around mid August. We will discuss the possible
							delays and corrections.
						</p>
					</section>
				</div>

				<div className='pb-12'>
					<section id='s4'>
						<h2 className='text-3xl font-bold text-[#C94C67]'>
							Disscusion
						</h2>
						<br></br>
						<u className='mt-3 text-gray-700 font-bold  textDecorationLine'>
							Fitting our curve with official CDC data
						</u>
						<p className='mt-3 text-gray-700'>
							Using past CDC (Center for Disease Control and
							Prevention) 2023 Tainan data for dengue fever is
							crucial for modeling the best time to implement our
							ovitraps, as it provides region-specific information
							about dengue outbreaks and transmission patterns.
							Through the CDC data, we are able to look at the
							periods within the year where there are the most
							dengue cases, allowing us to identify the critical
							points where the implementation of ovitraps is
							vital. The fit curve from the CDC data further
							refines this timing by highlighting the peak dengue
							season, which would correspond to the period when
							mosquito populations are the most active.
						</p>
						<img src={Imple4} alt='imp_img'></img>
						<p className='mt-2 text-gray-700'>
							The accuracy of our fit curve, according to past CDC
							data, deviates considerably from the standard
							acceptable margin of error.
						</p>
						<br></br>
						<div className='overflow-x-auto max-w-lg mx-auto p-6'>
							<table className='min-w-full table-auto border-collapse border border-gray-300'>
								<thead>
									<tr>
										<th className='border border-gray-300 px-4 py-2'>
											Evaluation Tool
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											Value
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<th className='border border-gray-300 px-4 py-2'>
											SSE
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											1.9029*10<sup>6</sup>
										</th>
									</tr>
									<tr>
										<th className='border border-gray-300 px-4 py-2'>
											RMSE
										</th>
										<th className='border border-gray-300 px-4 py-2'>
											97.0582
										</th>
									</tr>
								</tbody>
							</table>
						</div>
							<p className='mt-3 text-gray-700'>
								We used two different metrics to analyze our
								data: the SSE (Sum of Squared Errors) and the
								RMSE (Root Mean Square Error). SSE is the sum of
								the squared differences between the observed
								values and the predicted values of the dependent
								variable. Essentially, it is a measure of how
								well the regression model fits the data. In the
								context of our fit curve, the observed values
								are the data from the CDC, and the predicted
								values are the values generated by our model
								without accounting for delay. RMSE is the
								quadratic mean of the differences between the
								observed values and predicted ones.
							</p>
							<p className='mt-3 text-gray-700'>
								The high SSE and RMSE value of 97.0582 shows
								significant deviations, indicating errors have
								occurred. We hypothesized that it could be
								attributed to a lag between when cases are
								diagnosed and when they are officially recorded.
								Our model does not take into account such delay,
								which leads to differences between our
								model-predicted values and the actual cases of
								dengue. It also is missing the delay in the
								effectiveness of our solution. There’s also the
								significant impact of foreign cases from
								overseas right before summer that we’re not
								considering in this model. Given the difference
								between the peaks from our model and the CDC
								data, alongside the potential impact from the
								delays mentioned above, we hypothesize a
								correction of 60 days, making the optimal
								implementation timing the 170th day, and that
								will be late May.
							</p>
					</section>
				</div>

				<div className='pb-12'>
					<section id='s5'>
						<h2 className='text-3xl font-bold text-[#C94C67]'>
							Limitations/Future
						</h2>
						<br></br>
						<p className='mt-3 text-gray-700'>
							We understand that our model has limitations. One
							being that variables change during favorable
							periods. As the favorable period is during the
							summer, human behavior changes significantly.
							Traveling increases, meaning that the number of
							foreign cases of dengue increases as well. This
							leads to the limitation of our model, which is that
							we did not incorporate foreign cases from past CDC
							data for dengue fever. Therefore, we miss out on the
							increased cases for our model. Another reason may be
							that traveling leads to decreased upkeep or use of
							ovitraps. This results in less ovitrap activity
							during the favorable period.
						</p>
						<p className='mt-3 text-gray-700'>
							Another limitation of our model is that the only
							variable considered is temperature, and whether a
							period is favorable or not is solely dependent on
							that. For future developments, we plan to consider
							more entomological variables, such as UV and
							humidity. An increase in UV can lead to significant
							inhibition of egg hatching, larval development,
							pupation, and adult emergence. Increased humidity
							supports mosquito development and survival rates.
							These variables often change throughout the year and
							can also help determine a favorable and unfavorable
							period for mosquito activity. This correlates to the
							transmission of dengue fever and helps determine an
							ideal implementation time for the ovitraps.
						</p>
						<p className='mt-3 text-gray-700'>
							Also, the result of implementing our ovitraps will
							not be instantaneous with the decrease in dengue
							fever, as dengue cases take time to be discovered
							and recorded. This results in a delay in hospital
							records and public health data, as the eventual
							decrease in dengue cases as a result of ovitrap
							implementation will take time to take effect. The
							effectiveness of the ovitrap also depends on the
							variable of time, as the implementation of the
							ovitrap does not instantaneously result in a lowered
							dengue transmission rate.
						</p>
					</section>
				</div>
				<div className='pb-12'>
					<section id='s6'>
						<h2 className='text-3xl font-bold text-[#C94C67]'>
							References
						</h2>
						<br></br>
						<p className='mt-3 text-gray-700'>
							Carvalho, S. A., da Silva, S. O., & Charret, I. D.
							C. (2019). Mathematical modeling of dengue epidemic:
							control methods and vaccination strategies. Theory
							in biosciences = Theorie in den Biowissenschaften,
							138(2), 223–239.
							https://doi.org/10.1007/s12064-019-00273-7
						</p>
						<br></br>
						<p className='mt-3 text-gray-700'>
							Liao, C. M., Huang, T. L., Cheng, Y. H., Chen, W.
							Y., Hsieh, N. H., Chen, S. C., & Chio, C. P. (2015).
							Assessing dengue infection risk in the southern
							region of Taiwan: implications for control.
							Epidemiology and infection, 143(5), 1059–1072.
							https://doi.org/10.1017/S0950268814001745
						</p>
						<br></br>
						<p className='mt-3 text-gray-700'>
							Tainan City Government Dengue Fever Prevention
							Center. (n.d.). 112 local and imported cases. Tainan
							City Government.
							https://health.tainan.gov.tw/dengue/list.asp?orcaid=A0F28171-8555-4955-B4FB-33A3B
							874E86F&Topage=13 (((((problem)))))
						</p>
						<br></br>
						<p className='mt-3 text-gray-700'>
							Taiwan Centers for Disease Control. (n.d.). Dengue
							fever. Taiwan National Infectious Disease Statistics
							System.
							https://nidss.cdc.gov.tw/en/nndss/disease?id=061
						</p>
					</section>
				</div>
			</div>
		</div>
	);
};
export default ModelTab3;
